import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex gap-2 justify-center md:justify-start" }

import { getInitialsChar } from '@/utils/string'
import { PropType } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TableChips',
  props: {
  items: {
    type: Array as PropType<{ id: number; name: string }[]>,
    required: true,
    default: () => []
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items?.slice(0, 2) ?? [], (item) => {
      return (_openBlock(), _createBlock(_component_v_tooltip, {
        key: item.id,
        text: item.name,
        location: "top"
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_chip, _mergeProps(props, {
            color: "primary",
            text: `${_unref(getInitialsChar)(item.name, 6, false)}...`,
            class: "capitalize w-[70px]",
            size: "small",
            label: ""
          }), null, 16, ["text"])
        ]),
        _: 2
      }, 1032, ["text"]))
    }), 128)),
    (__props.items.length > 2)
      ? (_openBlock(), _createBlock(_component_v_tooltip, {
          key: 0,
          text: 
        __props.items
          .slice(2, __props.items.length)
          .map((item) => item.name)
          .join(', ')
      ,
          location: "top"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_chip, _mergeProps(props, {
              color: "primary",
              text: `+${__props.items.length - 2}`,
              class: "text-uppercase",
              size: "small",
              label: ""
            }), null, 16, ["text"])
          ]),
          _: 1
        }, 8, ["text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})